import * as Yup from "yup";

const FixedPriceSchema = Yup.object({
    product_search_string : Yup.string().required('This field is required!'),
    price : Yup.string().nullable().required('This field is required!'),
    quantity_available : Yup.number().required('This field is required!').nullable().typeError('Please enter a valid quantity!'),
    minimum_order_quantity : Yup.number().required('This field is required!').nullable().typeError('Please enter a valid price!'),
});

export default FixedPriceSchema